<template>
  <div class="publish-task-product">
    <steps :active="1"></steps>
    <el-row class="mobile-container">
    <el-row class="normal-from support">
      <el-col :xs="24" :sm="6" :md="6" :lg="6" :offset="9" class="mobile-offset">
        <h3 class="mobile-h3">收货地址</h3>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6" :lg="6" :offset="9" class="mobile-offset">
      <ul class="error-messages" v-if="!isEmptyErrors">
        <li v-for="error in errors">{{error[0].message}}</li>
      </ul>
      </el-col>
      <el-col :xs="6" :sm="3" :md="2" :lg="2" :offset="9" class="mobile-offset type" style="text-align: left;">
        服务类型：
      </el-col>
      <el-col :xs="8" :sm="3" :md="2" :lg="2">
        <el-radio class="service" v-model="support_transport_service" label="1" :disabled="support_order == '2' "  @change="selectSupport()">下单</el-radio>
      </el-col>
      <el-col :xs="8" :sm="3" :md="2" :lg="2" >
        <el-radio class="service" v-model="support_transport_service" style="margin-left:10px;" label="2" :disabled="support_buy == '2'"  @change="selectSupport()">下单+转运</el-radio>
      </el-col>
    </el-row>
    <el-row class="normal-from tip">
      <el-col :xs="24" :sm="6" :md="6" :lg="6" :offset="9" class="mobile-offset">
        <span v-if="support_transport_service == '1'" style="font-size: 10px;margin-bottom: 10px;color:#888">*无需下单人提供转运服务,寄至商家直邮的地址,您可能需要自己操作转运</span>
        <span v-if="support_transport_service == '2'" style="font-size: 10px;margin-bottom: 10px;color:#888">*需下单人提供转运服务,收货地址为中国大陆或香港,下单人替您操作转运,转运费实收</span>
      </el-col>
    </el-row>
    <el-row class="normal-from">
      <el-col :xs="24" :sm="6" :md="6" :lg="6" :offset="9" class="mobile-offset">
        <!-- <h3>添加收货地址</h3>
        <AddressForm v-on:success="submit"></AddressForm> -->
        <div class="address">
          <span v-if="support_transport_service == '1'">代下单收货地址</span>
          <span v-if="support_transport_service == '2'">代买收货地址</span>
          <AddressDialog style="float:right;width:50%;" v-if="address && !isSingle" :support_transport_service="support_transport_service">
            <span class="pointer" style="float:right;margin-bottom: 10px;" @click="showForm = true"><span class="add-tip">更改地址</span></span>
            <!-- <el-button type="info" style="float:right;width:50%;margin-bottom: 10px;" class="block btn-14" >更改地址</el-button> -->
          </AddressDialog>
          <AddAddressDialog  style="float:right;width:50%;" v-on:success="addAddress"  v-if="!address || isSingle" :support_transport_service="support_transport_service">
            <span class="pointer" style="float:right;margin-bottom: 10px;" @click="showForm = true" v-if="!address"> <span class="add-tip">添加地址</span></span>
            
            <!-- <el-button type="info" style="float:right;width:50%;margin-bottom: 10px;" @click="showForm = true" class="block btn-14" v-if="!address">添加地址</el-button>
            <el-button type="info" style="float:right;width:50%;margin-bottom: 10px;" @click="showForm = true" class="block btn-14" v-if="address">更改地址</el-button> -->
          </AddAddressDialog>
          <AddAddressDialog  style="float:right;width:50%;" v-on:success="addAddress" :address="address" v-if="address && isSingle" :support_transport_service="support_transport_service">
            <span class="pointer" style="float:right;margin-bottom: 10px;" @click="showForm = true" v-if="address"> <span class="add-tip">编辑地址</span></span>
          </AddAddressDialog>
        </div>
        <!-- <div class="line"></div> -->
        <div v-if="address">
          <SingleAddress class="address-info" :address="taskInfo.address_info"></SingleAddress>
        </div>
        <el-button :loading="isFetchingPrice" :disabled="!address || isDisabled" class="block next" type="info" @click="taskInfoSubmit()">{{ isFetchingPrice?'提交数据中':'确定' }}</el-button>
      </el-col>
    </el-row>
    </el-row>
  </div>
</template>

<script>
import AddressForm from './Form'
import steps from '../components/Steps'
import api from '../../../services/api.js'
import SingleAddress from './SingleAddress'
import AddressDialog from './AddressDialog'
import AddAddressDialog from './AddAddressDialog'

let _ = require('lodash')

export default {
  name: 'AddAddress',
  props: ['addressInfo'],
  components: {
    steps: steps,
    AddressForm: AddressForm,
    SingleAddress: SingleAddress,
    AddressDialog: AddressDialog,
    AddAddressDialog: AddAddressDialog,
  },
  created () {
    this.isSingle = this.$route.fullPath.indexOf('buyer') > -1
    this.support_transport_service = this.taskInfo.support_transport_service || '1'
    this.address = this.taskInfo.address_info
    if(this.support_transport_service == '1' && this.support_order == '2'){
      this.support_transport_service = '2'
      this.address = null
    }
    if(this.support_transport_service == '2' && this.support_buy == '2'){
      this.support_transport_service = '1'
      this.address = null
    }
    if(!this.isSingle){
      this.getAddressList()
    }
    this.getBusiness()
  },
  computed: {
    taskInfo () {
	    return this.$store.state.taskInfo
    }
  },
  data () {
    return {
      isFetchingPrice:false,
      support_transport_service: '1',
      isSingle: false,
      addressList: null,
      address: null,
      support_order: null,
      support_buy: null,
      isEmptyErrors: true,
      errors: null,
      isDisabled:false,
      condition: {
        single_id: '0', // 下单人
        single_name: null,
        buyer_id: '0', // 下单人
        buyer_name: null,
        rate: 1, // 汇率
        amount_currency: 0, // 任务金额（原币种）
        amount: 0, // 任务金额（人民币）
        response_hours: '立即响应', // 响应时间
        after_sale_service: '不需要售后服务', // 售后服务
        score: '下单人评分', // 评分
        remark: null, // 备注
        check_full_goods: false, // 缺货是否仍可下单，0否，1是
        transport_amount_charge_type: '3', // 运费计费方式，1: 国际邮费按包裹重量实收 2: 国际运费包邮/已记 3: 输入国际邮费金额
        package_forwarding_fee: '0.00' // 国际运费
      },
    }
  },
  methods: {
    async getBusiness () {
      let query = {
          id: this.taskInfo.business_id
        }
        let res = await api.getListByWebsite(this, query)
        if(res.body.result){
          this.support_order = res.body.result[0].support_order
          this.support_buy = res.body.result[0].support_buy
          if(this.support_order == '2' && this.support_buy == '2'){
            this.isDisabled = true
          }
          if(this.support_order == '2' && this.support_buy != '2'){
            this.support_transport_service = '2'
          }
          if(!this.isSingle){
            if(this.support_order == '0' && this.support_buy != '0'){
              this.isEmptyErrors = false
              this.errors = {
                support_order: [
                  {message: '暂不确定是否支持代下单, 建议先咨询客服或下单人'}
                ]
              }
            }
            if(this.support_buy == '0' && this.support_order != '0'){
              this.isEmptyErrors = false
              this.errors = {
                support_buy: [
                  {message: '暂不确定是否支持代买, 建议先咨询客服或下单人'}
                ]
              }
            }
            if(this.support_order == '0' && this.support_buy == '0'){
              this.isEmptyErrors = false
              this.errors = {
                support_order: [
                  {message: '暂不确定是否支持代下单/代买, 建议先咨询客服或下单人'}
                ]
              }
            }
          }
        }
    },
    async getAddressList () {
      let res = await api.getAddressList(this)
      this.addressList = res.body.result
      if(this.addressList){
        if(this.support_transport_service == 1){
          this.address = this.addressList[0]
          this.taskInfo.address_id = this.address.id
          this.taskInfo.address_info = this.address
          this.$store.commit('updateTaskInfo', this.taskInfo)
        }
        if(this.support_transport_service == 2){
          _.each(this.addressList, item => {
            if(item.country == '中国香港(HK)' || item.country == '中国大陆(CN)'){
              this.address = item
              this.taskInfo.address_id = this.address.id
              this.taskInfo.address_info = this.address
              this.$store.commit('updateTaskInfo', this.taskInfo)
              return false
            }
          })
        }
      }
    },
    selectSupport () {
      this.address = null
      if(!this.isSingle){
        this.getAddressList()
      }
    },
    addAddress () {
      this.address = this.taskInfo.address_info
    },
    async taskInfoSubmit () {
      this.isFetchingPrice=true
      this.taskInfo.type=0
      this.taskInfo.support_transport_service = this.support_transport_service
      this.taskInfo.service_type=this.support_transport_service
      this.taskInfo.merchant_id=this.taskInfo.business_id
      this.$store.commit('updateTaskInfo', this.taskInfo)

      let payment = await this.getLatestPaymentType()
      let path = 'payment'
      if (this.isSingle) {
        path = 'confirm'
      } else if (payment) {
        this.taskInfo.payment_type_id = payment.id
        this.taskInfo.payment_type_info = payment
        path = 'confirm'
      }

      api.post(this, {
            path: 'order.php?api=get_price_info&type=1',
            data: this.taskInfo,
            loading: 'loading'})
      .then((response)=>{
        let res=response.body
        this.isFetchingPrice=false
        this.taskInfo.conditions=this.condition;
        if(res.result.international_transport_price){
          this.taskInfo.conditions.package_forwarding_fee=res.result.international_transport_price.value;
          this.taskInfo.conditions.transport_amount_charge_type==res.result.international_transport_price.charge_type
          this.taskInfo.conditions.rate=res.result.rate
        }
        this.taskInfo.amount=res.result.goods_price.value
        this.taskInfo.tax_amount=res.result.tax_price.value
        this.taskInfo.service_amount=res.result.service_price.value
        this.taskInfo.transport_amount=res.result.transport_price.value
        this.taskInfo.subtotal_amount=res.result.subtotal_price.value
        this.taskInfo.rmb_total_amount=res.result.total_price.value
        this.taskInfo.total_amount=res.result.ori_total_price.value
        this.taskInfo.other_amount=res.result.other_price.value
        this.taskInfo.currency_rate=res.result.rate
        this.taskInfo.currency_symbol=res.result.goods_price.currency_symbol
        this.taskInfo.currency=res.result.goods_price.currency
        this.$store.commit('updateTaskInfo', this.taskInfo)
        this.$router.push({ path: path, query: this.$route.query })
      })
      
      //this.$router.push({ path: 'condition', query: this.$route.query})
    },
    async getLatestPaymentType () {
      let res = await api.getLatestPaymentType(this)
      return res.body.result
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.error-messages{
    display: block;
    background-color: #f4f4f5;
    padding: 10px;
    text-align: center;
    color: #909399;
    line-height: 17px;
    margin-bottom: 10px;
    border-radius: 5px;
}
.tip {
  margin-top: 5px;
}
.address{
  margin: 15px 0 10px;

  span{
    font-size: 16px;
    line-height: 32px;
    color: #888;
  }
  .pointer {
    span {
      font-size: 14px;
      color: #888;
      text-decoration: underline;
    }

    .add {
      font-size: 15px !important;
      letter-spacing: 0.1px !important;
      font-family: 'Function Pro Demi' !important;
      color: #333 !important;
      line-height: 33px !important;
    }
  }
  
}
.line{
  height: 1px;
  background: #d7d7d7;
  margin-bottom: 10px;
}
.next {
  margin-top: 20px;
}
.type {
  text-align: center;
}
@media screen and (max-width:760px){
  .mobile-container {
    padding: 0 10px;
    .mobile-h3 {
      margin: 10px 0 20px;
    }

    .mobile-offset {
      margin-left: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/address/Address.vue